$('.block-gallery-filter').each(function() {

    const filters = $(this).find('.gallery-filter-button');
    const select = $(this).find('.gallery-filter-select');
    const items = $(this).find('.gallery-image-item');
    const sentinel = $(this).find('.gallery-sentinel')[0];

    const pageSize = 12;
    let currentFilter = 'all';
    let revealCount = pageSize;

    function matches(item) {
        return currentFilter === 'all' || $(item).attr('data-image-category') === String(currentFilter);
    }

    function render() {
        let shown = 0;

        items.each(function() {
            if (!matches(this)) {
                $(this).removeClass('is-visible').addClass('is-hidden');
                return;
            }

            shown++;

            if (shown > revealCount) {
                $(this).removeClass('is-visible').addClass('is-hidden');
                return;
            }

            if ($(this).hasClass('is-hidden')) {
                $(this).removeClass('is-hidden');
                requestAnimationFrame(() => $(this).addClass('is-visible'));
            } else {
                $(this).addClass('is-visible');
            }
        });
    }

    function activate(value) {
        currentFilter = value;
        revealCount = pageSize;
        render();
    }

    filters.on('click', function() {

        const index = $(this).data('index');

        filters.removeClass('is-active');
        $(this).addClass('is-active');

        if (select.length) {
            select.val(index);
        }

        activate(index);

    });

    select.on('change', function() {

        const value = $(this).val();

        filters.toggleClass('is-active', value === 'all');

        activate(value);

    });

    if (sentinel) {
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    revealCount += pageSize;
                    render();
                }
            });
        });
        observer.observe(sentinel);
    }

    render();

});
